import React from "react";
import { Box, Typography, Button, Stack } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useNavigate } from "react-router-dom";

const FallbackPage = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#fff",
      }}
    >
      <Box sx={{ py: 2, px: 3, borderBottom: "1px solid #EAEAEA" }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <img
            src="/assets/icons/LZ-logo-face.svg"
            alt="logo face"
            style={{ marginBottom: "2px" }}
          />
          <img src="/assets/icons/LZ-logo.svg" alt="logo" />
        </Stack>
      </Box>

      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#FAFAFA",
          px: 2,
        }}
      >
        <Stack
          alignItems="center"
          spacing={3}
          sx={{
            textAlign: "center",
            maxWidth: 480,
            py: 8,
            px: 4,
          }}
        >
          <Box
            sx={{
              width: 120,
              height: 120,
              borderRadius: "50%",
              backgroundColor: "#E8F5E9",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ErrorOutlineIcon
              sx={{ fontSize: 60, color: "#0C7F44" }}
            />
          </Box>

          <Box>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 700,
                color: "#333",
                mb: 1,
                fontFamily: "Helvetica",
              }}
            >
              Oops!
            </Typography>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 600,
                color: "#333",
                mb: 1.5,
                fontFamily: "Helvetica",
              }}
            >
              Page Not Found
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#666",
                lineHeight: 1.7,
                fontFamily: "Helvetica",
              }}
            >
              The page you're looking for doesn't exist or has been moved.
            </Typography>
          </Box>

          <Button
            variant="contained"
            startIcon={<HomeIcon />}
            onClick={() => navigate("/")}
            sx={{
              backgroundColor: "#0C7F44",
              color: "#fff",
              px: 5,
              py: 1.5,
              fontWeight: "bold",
              textTransform: "none",
              borderRadius: 1,
              fontFamily: "Helvetica",
              "&:hover": {
                backgroundColor: "#0c7f44",
              },
            }}
          >
            Back to Home
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

export default FallbackPage;